import { createContext } from "react";

const SiteContext = createContext(null);

export default SiteContext;
